// extracted by mini-css-extract-plugin
export default {"infoText":"ManagerSelector-module__infoText___NPukV"};